// © Microsoft Corporation. All rights reserved.

import { ElementStyles, css } from "@microsoft/fast-element";
import { elevation, heightNumber, neutralForegroundRestBehavior, neutralLayerFloatingBehavior, neutralOutlineRestBehavior } from "@fluentui/web-components";

import { DirectionalStyleSheetBehavior } from "@microsoft/fast-foundation";
import { ZIndex } from "@msnews/core";

const dialogZIndex = `${ZIndex.Dialog}`;

const ltr = css`
    .settings-dialog {
        transform: translateX(-90%)
    }
`;

const rtl = css`
    .settings-dialog {
        transform: translateX(90%)
    }
`;

export const SettingsStyles: ElementStyles = css`
    .hidden {
        display: none;
    }

    .language-dropdown-placeholder {
        width: 288px;
        height: 32px;
        background-color: ${neutralOutlineRestBehavior.var};
        margin-top: 12px;
        border: 1px solid ${neutralOutlineRestBehavior.var};
        border-radius: 2px;
    }

    .settings-button {
        align-items: center;
        display: flex;
        height: calc(${heightNumber} * 1px);
        justify-content: center;
        width: calc(${heightNumber} * 1px);
    }

    .settings-button::part(control) {
        height: calc(${heightNumber} * 1px);
        width: calc(${heightNumber} * 1px);
    }

    .settings-close-button {
        height: calc(${heightNumber} * 1px);
        width: calc(${heightNumber} * 1px);
        background: ${neutralLayerFloatingBehavior.var}
    }

    .close-button-glyph {
        height: 12px;
        width: 12px;
    }

    .settings-dialog {
        --elevation: 11;
        ${elevation}
        min-height: 194px;
        width: 320px;
        background: ${neutralLayerFloatingBehavior.var};
        border: calc(var(--outline-width) * 1px) solid transparent;
        border-radius: var(--elevated-corner-radius);
        display: flex;
        flex-direction: column;
        z-index: ${dialogZIndex};
        position: absolute;
    }

    .without-market-selector {
        height: 106px;
    }

    .settings-dialog-header {
        display: flex;
        flex-direction: row;
    }

    .settings-dialog-title {
        margin: 12px auto 8px;
        margin-inline-start: 16px;
        font-size: var(--type-ramp-plus-1-font-size);
        line-height: var(--type-ramp-plus-1-line-height);
        font-weight: 600;
    }

    .language-dropdown {
        margin: 8px 16px;
        font-size: var(--type-ramp-base-font-size);
        line-height: var(--type-ramp-base-line-height);
    }

    .personalize-settings {
        display: flex;
        flex-direction: row;
        margin: 8px 16px;
        justify-content: space-between;
        align-items: center;
        font-size: var(--type-ramp-base-font-size);
        line-height: var(--type-ramp-base-line-height);
    }

    .personalize-settings-button {
        border: 1px solid ${neutralOutlineRestBehavior.var};
        border-radius: 2px;
        padding: 0;
        margin: 0 0 0 15px;
        font-size: var(--type-ramp-base-font-size);
        line-height: var(--type-ramp-base-line-height);
        box-sizing: border-box; 
        cursor: pointer;
        color: ${neutralForegroundRestBehavior.var};
        fill: ${neutralForegroundRestBehavior.var};
        height: fit-content;
    }

    .personalize-settings-button::part(content) {
        max-width: 115px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .personalize-settings-button::part(control) {
        width: 100%;
        white-space: normal;
        padding: 6px 12px;
    }
`.withBehaviors(
        neutralOutlineRestBehavior,
        neutralForegroundRestBehavior,
        neutralLayerFloatingBehavior,
        new DirectionalStyleSheetBehavior(ltr, rtl)
    );
